export interface IQuery { }

export class GridProjectByIdQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Projects.Queries.GridProjectByIdQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	PortfolioId: string
	ProjectId: string

	constructor (workspaceId: number, portfolioId: string, projectId: string)
	{
		this.WorkspaceId = workspaceId
		this.PortfolioId = portfolioId
		this.ProjectId = projectId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Projects.Queries.GridProjectByIdQueryV1, TCh.Domain.Quest'
	}

}

export class MyPortfolioProjectsPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.Projects.Queries.MyPortfolioProjectsPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	TchProjectId: number

	constructor (workspaceId: number, tchProjectId: number)
	{
		this.WorkspaceId = workspaceId
		this.TchProjectId = tchProjectId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.Projects.Queries.MyPortfolioProjectsPageQueryV1, TCh.Domain.Quest'
	}

}

